import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import '@fontsource-variable/inter';
// The landing-editor canvas renders public blocks, so it needs the public fonts too (decision 0004).
import '@fontsource-variable/inter-tight/wght.css';
import '@fontsource/instrument-serif/latin-400-italic.css';
import '@fontsource/instrument-serif/latin-ext-400-italic.css';
import '@agency/design-tokens/tokens.css';
import '@agency/ui/ui.css';
import '@agency/public-blocks/blocks.css';
import './admin.css';
import { App } from './App.tsx';
import { AuthProvider } from './lib/auth.tsx';

const qc = new QueryClient({ defaultOptions: { queries: { staleTime: 10_000, retry: (n, e) => n < 2 && (e as { retryable?: boolean }).retryable === true, refetchOnWindowFocus: false } } });

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={qc}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
